import EventActionProto from '../event-action-proto'
import {EVENT_BUS_SESSION_PORTFOLIO_CHANGED} from "../../model2/project-collection/events";

export default class EventPortfolioDelete extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)

        this.method     = sessionEvent.method
        this.header     = {
            portfolioId: sessionEvent.portfolioId,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        // remove project from projects
        const sessionProjectCollection = gd.session.projectCollections.get(this.header.portfolioId)
        if (sessionProjectCollection) {
            gd.session.projectCollections.remove(this.header.portfolioId)
            gd.bus.triggerEvent(EVENT_BUS_SESSION_PORTFOLIO_CHANGED)

            gd.modelBus.newUpdate('portfolio', this.method, this.header.portfolioId, this.data, this.header)
        }
    }
}

